import { render, staticRenderFns } from "./rewardList.vue?vue&type=template&id=67b6cbfb&scoped=true&"
import script from "./rewardList.vue?vue&type=script&lang=js&"
export * from "./rewardList.vue?vue&type=script&lang=js&"
import style0 from "./rewardList.vue?vue&type=style&index=0&id=67b6cbfb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b6cbfb",
  null
  
)

export default component.exports